<template>
  <div class="md:mx-4 lg:mx-8 text-dark">
    <div class="text-center ">

      <h5 class="font-bold text-warning aicolor">improvee.io AI</h5>
      <h1 class="text-5xl font-black text-black">personalized tip</h1>
      <div class="mt-8" >
        <div class="text-left" v-html="componentData.longMessage"/>
        <div class="flex justify-center mt-2">
          <star-rating class="mt-8" @rating-selected="ratingSave" :show-rating="false" v-model="notification.rating" :star-size="20" active-color="#0CF2AD"></star-rating>
          </div>
      </div>

    </div>




  </div>
</template>

<script>
import StarRating from 'vue-star-rating'

export default {
  components: {
    StarRating
  },
  props: ['componentData'],
  data () {
   return {
      notificationDefaults: {
        rating: null
      },
      notification: {},
    }
  },
  watch: {
    'componentData': {
      immediate: true,
      async handler (editedEntity) {
        if (editedEntity) {
          this.notification = _.merge({}, this.notificationDefaults, editedEntity)
          this.dontWantTips = this.$store.getters.aiTipsDisabled
          if (window.smartlook) {
            window.smartlook('track', 'aiTipOpened', { userId: this.$store.getters.userId })
          }
        }
      }
    },
   },
  computed: {
  },
  methods: {
    ratingSave () {
        this.$store.dispatch('UPDATE_NOTIFICATION', { notification: this.componentData, updateFields: { rating: this.notification.rating } })
    }
  }
}
</script>
